import { shippingBadge, type OrderState, type Shipping } from '@/domain';
import { SHIPPING_BADGE_LABEL } from './shippingLabels';
import { StatusDot } from './StatusDot';

/**
 * Where a case stands on its way to the customer, in one pill. Section 7 of the
 * request of 13 September 2026.
 *
 * The same words on the shipping screen, the orders list, the logistics column
 * and the case record, so "Shipped" means one thing wherever somebody reads it.
 * The rule behind it is `shippingBadge` in the domain, and the tones are the
 * StatusDot vocabulary every other row already uses.
 *
 * The archive drew it too, from what a row carries, until the request of
 * 5 October 2026 (third), section 11: a row there now says Shipped or Received,
 * the two the list filters by.
 */
export function ShippingBadge({
  order,
}: {
  order: { state: OrderState; dispatch: Pick<Shipping, 'status' | 'method'> };
}) {
  const badge = shippingBadge(order);
  return <StatusDot tone={badge.tone}>{SHIPPING_BADGE_LABEL[badge.key]}</StatusDot>;
}
